import { useLang } from "@/providers/langProvider";

interface Props {
  full?: boolean;
  half?: boolean;
  large?: boolean;
  small?: boolean;
}
const SvgCommonStar: React.FC<Props> = ({ large, small, full, half }) => {
  const lang = useLang();
  const rtl = lang === "ar";
  const style = large
    ? { transform: "scale(2)", margin: 9 }
    : small
    ? { transform: "scale(0.66)", margin: -3 }
    : {};
  return (
    <svg
      style={style}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector 2"
          d="M9.5035 1.87501C9.39838 1.87435 9.29517 1.90317 9.20558 1.95819C9.116 2.01321 9.04362 2.09223 8.99667 2.18629L7.06454 6.05055L2.47665 6.7566C2.37396 6.77247 2.27766 6.81647 2.19845 6.88373C2.11924 6.95098 2.0602 7.03886 2.02789 7.13763C1.99558 7.23639 1.99125 7.34217 2.01539 7.44324C2.03952 7.54431 2.09118 7.63672 2.16464 7.71022L5.33822 10.8838L4.63143 15.4768C4.61562 15.5796 4.6286 15.6847 4.66892 15.7805C4.70924 15.8764 4.77533 15.9592 4.85985 16.0197C4.94437 16.0802 5.04401 16.1162 5.14772 16.1235C5.25143 16.1309 5.35514 16.1093 5.44735 16.0613L9.49984 13.9468L13.5523 16.0613C13.6445 16.1093 13.7483 16.1309 13.852 16.1235C13.9557 16.1162 14.0553 16.0802 14.1398 16.0197C14.2244 15.9592 14.2904 15.8764 14.3308 15.7805C14.3711 15.6847 14.3841 15.5796 14.3683 15.4768L13.6615 10.8838L16.835 7.71022C16.9085 7.63672 16.9602 7.54431 16.9843 7.44324C17.0084 7.34217 17.0041 7.23639 16.9718 7.13763C16.9395 7.03886 16.8804 6.95098 16.8012 6.88373C16.722 6.81647 16.6257 6.77247 16.523 6.7566L11.9351 6.05055L10.003 2.18629C9.95662 2.09334 9.88538 2.01506 9.79722 1.96011C9.70905 1.90517 9.60739 1.87572 9.5035 1.87501Z"
          className={`${full || (half && rtl) ? "fill-yellow" : "fill-gray4"}`}
        />
        <path
          id="Vector"
          d="M9.49988 1.875V13.9463L5.44613 16.0613C5.25863 16.1588 5.03363 16.1438 4.86113 16.02C4.68863 15.8963 4.59863 15.6863 4.63238 15.4763L5.33738 10.8825L2.16488 7.71C2.01488 7.56 1.96238 7.33875 2.02613 7.13625C2.09363 6.9375 2.26613 6.7875 2.47613 6.7575L7.06613 6.0525L8.99738 2.18625C9.09113 1.995 9.28613 1.875 9.49988 1.875Z"
          className={`${full || (half && !rtl) ? "fill-yellow" : "fill-gray4"}`}
        />
      </g>
    </svg>
  );
};

export default SvgCommonStar;

export const starStatus = (index: number, rate: number) => {
  const roundRate = Math.round(rate * 2) / 2;
  return {
    full: index < Math.floor(roundRate),
    half: index + 0.5 === roundRate,
  };
};
